import { render } from "./UIExampleContainer.vue?vue&type=template&id=149e3edc&scoped=true&ts=true"
import script from "./UIExampleContainer.vue?vue&type=script&lang=ts"
export * from "./UIExampleContainer.vue?vue&type=script&lang=ts"

import "./UIExampleContainer.vue?vue&type=style&index=0&id=149e3edc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149e3edc"]])

export default __exports__